import { provideTranslocoScope } from '@jsverse/transloco';
import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListPageColumnComponent } from 'design-system';

interface CustomerAlert {
  stato: string | null;
  valore: number | null;
  toolTip: string | null;
}

@Component({
  providers: [provideTranslocoScope('receipts')],
  selector: 'rev-customer-alert-cell',
  imports: [MatTooltipModule, NgClass],
  templateUrl: './receipts-customer-alert-cell.html',
  styleUrl: './receipts-customer-alert-cell.scss',
})
export class receiptsCustomerAlertCell extends ListPageColumnComponent implements OnInit {
  @Input() alert?: CustomerAlert;

  ngOnInit(): void {
    if (this.itemData && this.infoColumn) {
      this.alert = this.itemData[this.infoColumn.columnNameDef];
    }
  }

  get visualState(): 'success' | 'info' | 'warning' | 'danger' {
    switch (this.alert?.stato) {
      case 'Info':
        return 'info';
      case 'Warning':
      case 'warn':
        return 'warning';
      case 'Danger':
      case 'err':
        return 'danger';
      default:
        return 'success';
    }
  }

  get icon(): string {
    switch (this.visualState) {
      case 'info':
        return 'fa-circle-info';
      case 'warning':
        return 'fa-triangle-exclamation';
      case 'danger':
        return 'fa-circle-exclamation';
      default:
        return 'fa-circle-check';
    }
  }
}
